import React, { useState, useEffect, useRef, useCallback } from 'react';
import './WorksPage.css';
import WorkModal from './WorkModal';

import { useData } from '../DataProvider';

const WorkGridCard = ({ data, audio }) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [lastMousePosition, setLastMousePosition] = useState(null);
  const fadeTimers = useRef({ fadeIn: null, fadeOut: null });
  const { data: providerData } = useData();
  

  const divRef = useRef(null);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const fadeInAudio = (audio, duration = 1000) => {
    clearInterval(fadeTimers.current.fadeOut); // 기존 fadeOut 중지
    clearInterval(fadeTimers.current.fadeIn); // 기존 fadeIn 중지
  
    audio.volume = 0;
    audio.currentTime = 0;
    audio.play();
  
    const step = 0.05;
    const interval = duration / (1 / step);
  
    fadeTimers.current.fadeIn = setInterval(() => {
      if (audio.volume < 1) {
        audio.volume = Math.min(audio.volume + step, 1);
      } else {
        clearInterval(fadeTimers.current.fadeIn);
      }
    }, interval);
  };
  
  const fadeOutAudio = (audio, duration = 1000, callback) => {
    clearInterval(fadeTimers.current.fadeIn); // 기존 fadeIn 중지
    clearInterval(fadeTimers.current.fadeOut); // 기존 fadeOut 중지
  
    const step = 0.05;
    const interval = duration / (1 / step);
  
    fadeTimers.current.fadeOut = setInterval(() => {
      if (audio.volume > 0) {
        audio.volume = Math.max(audio.volume - step, 0);
      } else {
        clearInterval(fadeTimers.current.fadeOut);
        audio.pause();
        if (callback) callback();
      }
    }, interval);
  };

  const playAudio = () => {
    if (isPlaying)
      return;
    if (providerData.muted)
      return;

    setIsPlaying(true);
    fadeInAudio(audio, 800); // 800ms 동안 페이드인
  }

  const stopAudio = useCallback(() => {
    if (!isPlaying)
      return;

    setIsPlaying(false);
    fadeOutAudio(audio, 800); // 800ms 동안 페이드아웃

  }, [isPlaying, audio]); 

  const stopAudioImmediate = useCallback(() => {
    if (!isPlaying)
      return;

    console.log("Immiediate Stop")
    setIsPlaying(false);
    audio.pause();

  }, [isPlaying, audio]); 

  const stopAudioIfSafari = useCallback(()=>{
    if (window.innerWidth < 833)
    {
      if (/iPad|iPhone|iPod/.test(navigator.userAgent))
        stopAudioImmediate();
    }
  }, [stopAudioImmediate])

  const checkMouseInsideDiv = useCallback((position) => {
    if (divRef.current) {
      const rect = divRef.current.getBoundingClientRect();
      const isInside =
        position.x >= rect.left &&
        position.x <= rect.right &&
        position.y >= rect.top &&
        position.y <= rect.bottom;
  
      if (!isInside) {
        stopAudio();
      }
    }
  }, [stopAudio]);  


  const closeModal = () => {
    if (lastMousePosition) {
      checkMouseInsideDiv(lastMousePosition); 
    }
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (isPlaying) {
      const handleMouseMove = (e) => {
        const currentMousePosition = { x: e.clientX, y: e.clientY };
        setLastMousePosition(currentMousePosition); 
        if(!isModalOpen)
          checkMouseInsideDiv(currentMousePosition);
      }
        document.addEventListener('mousemove', handleMouseMove);
        return () => {
        document.removeEventListener('mousemove', handleMouseMove);
      };
  }
  }, [isPlaying, isModalOpen, checkMouseInsideDiv]);



  return (
    <div ref={divRef} className="image-container grid-item" onMouseOver={playAudio} onMouseLeave={stopAudioIfSafari}>
      <div className='thumbnail-container'>
        <img src={data['preview-filename']} alt=''></img>
      </div>
      <div className="image-overlay" onClick={openModal}></div>
      <div className="overlay-text-name default-text">{data['title']}</div>
      <div className="overlay-text-info default-text grey-text">{data['thumbnail-info']}</div>

      <WorkModal isOpen={isModalOpen} onRequestClose={closeModal} data={data} />
    </div>
  )
}

export default WorkGridCard;
